<template>
    <div>
        <Modal size="md" @close="$emit('close')">
            <template #header>
                <div class="text-gray-600">
                    Manage recurring payment requests
                </div>
            </template>

            <template #body>
                <div class="flex flex-col gap-4 border-t border-gray-200 p-6">
                    <div
                        v-for="subscription in [pro, plugin]"
                        :key="subscription?.id"
                    >
                        <div v-if="subscription">
                            <div class="text-base font-medium text-gray-800">
                                {{ subscription.subscription_plan_uuid }}
                            </div>

                            <AtomicButton
                                class="mt-2"
                                :color="
                                    subscription.recurring_payment_request
                                        ? 'red'
                                        : 'yellow'
                                "
                                size="md"
                                @click="
                                    subscription.recurring_payment_request
                                        ? disable(subscription.id)
                                        : enable(subscription.id)
                                "
                            >
                                {{
                                    subscription.recurring_payment_request
                                        ? 'Disable'
                                        : 'Enable'
                                }}
                            </AtomicButton>
                        </div>
                    </div>
                </div>
            </template>

            <template #footer>
                <div class="flex justify-end border-t border-gray-200 p-6">
                    <AtomicButton
                        color="white"
                        size="md"
                        @click="emit('close')"
                    >
                        Cancel
                    </AtomicButton>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
import ISubscription from '@/types/Subscription/ISubscription';

const emit = defineEmits(['close', 'enable', 'disable']);

defineProps<{
    pro: ISubscription | undefined;
    plugin: ISubscription | undefined;
}>();

const enable = (id: number) => {
    emit('enable', id);
};

const disable = (id: number) => {
    emit('disable', id);
};
</script>
